import { sendGAEvent, sendGTMEvent } from '@next/third-parties/google';

function formattedCapitalize(str: string): string {
  return str.replace(/(^|_)(\w)/g, (_, __, letter) => letter.toUpperCase());
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SendEventAnalytic = (eventName: string, value: Record<string, unknown>) => {
  sendGAEvent('event', eventName, value);
  sendGTMEvent(value, eventName);
};

export const SendEventMetapixel = (eventName: string, value: Record<string, unknown>) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', formattedCapitalize(eventName), value ? value : {});
  }
};
